import {
  SuperpoweredWebAudio,
} from "../../lib/superpowered/SuperpoweredWebAudio.js";

import { getWavBytes } from '../../factories/AudioConvertor'
import { setAssetItem } from "../assetStore/index.js";

// pgw 03-apr-2025
// let doprint = true;
let doprint = false;


class AudioEngine {
  processorNode;
  webaudioManager;
  playing = false;
  superpowered = null;
  currentPositonPollingInterval = null;
  currentPosition = 0;
  peaks = {
    channels: []
  }

  constructor() {
    this.boot();
    this.sendPlayCommand = this.sendPlayCommand.bind(this);

	// pgw 31-mar-2025
	// Oops - this was missing !
    this.sendLoopCommand = this.sendLoopCommand.bind(this);

    this.sendRecordCommand = this.sendRecordCommand.bind(this);
    this.loadChannelBuffers = this.loadChannelBuffers.bind(this);
    this.onMessageProcessorAudioScope = this.onMessageProcessorAudioScope.bind(this);
    this.sendRequestCurrentEngineStateCommand = this.sendRequestCurrentEngineStateCommand.bind(this);
    this.sendMasterMuteCommand = this.sendMasterMuteCommand.bind(this);
    this.getChannelPeak = this.getChannelPeak.bind(this);
    window.ramUsage = '0 mb';
    this.stateInterval = null;
  }

  async boot() {
    // await this.loadSP();
  }

  getChannelPeak(index) {
    if (this.peaks && this.peaks.channels.length) {
      // if (index === 9) console.log(this.peaks.channels[index]);
      return this.peaks.channels[index];
    } else {
      return 0;
    }
  }

  async loadSP(offlineRenderingOptions = null) {

	// pgw 22-jul-2024
	// Bug fix from Tom 
    // this.webaudioManager = new SuperpoweredWebAudio(48000, this.superpowered, offlineRenderingOptions);
    this.webaudioManager = new SuperpoweredWebAudio(44100, this.superpowered, offlineRenderingOptions);

    this.testTone = this.webaudioManager.audioContext.createOscillator();
    this.stereoInputNode = this.webaudioManager.audioContext.createPanner();
    this.testTone.channelInterpretation = 'speakers';
    this.testTone.start(); 
    this.superpoweredLoaded = true;
  }

  async unloadSp() {
    if (this.superpowered) {
      this.testTone = null;
      this.webaudioManager = null;
      this.superpowered = null;
    }
  }

  startCurrentEngineStatePolling() {
    // console.log('starting currentPositionPolling');
    if (this.processorNode) {
      this.stateInterval = setInterval(()=> {
        if (this.processorNode) {
          this.sendRequestCurrentEngineStateCommand();
        } else {
          clearInterval(this.stateInterval);
        }
      }, 30);
  }
  }


  async onMessageProcessorAudioScope(message) {
    // console.log(message);
    if (message.event === "channelBuffersLoaded") {
      this.startCurrentEngineStatePolling()
      this.loadMultipleBuffersCallback();
      // this.encodedBuffers = null;
    }
    if (message.event === "singleChannelBufferLoaded") {
      if (this.loadSingleBufferCallback) this.loadSingleBufferCallback();
    }
    if (message.event === "bufferRecorded") {
      // get WAV file bytes and audio params of your audio source
      const wavBytes = getWavBytes(message.data.buffer, {
        isFloat: true, // floating point or 16-bit integer
        numChannels: 2,
        sampleRate: 48000,
      });
      // console.log(wavBytes);
      const wav = new Blob([wavBytes], { type: "audio/wav" });

      // // create download link and append to Dom
      // const downloadLink = document.createElement("a");
      // downloadLink.href = URL.createObjectURL(wav);
      // downloadLink.innerText = "Download";
      // downloadLink.style.float = 'right';
      // downloadLink.setAttribute("download", "my-audio.wav"); // name file
      // document.getElementById("root").appendChild(downloadLink);


      // encode to mp3 and store in indexdb
      const arrayBufferWav = await wav.arrayBuffer()

      setAssetItem(message.data.id, arrayBufferWav);

      // const mp3URL = await endodeArrayBufferToMp3( `user${message.data.index}.mp3`, wavBytes,);
      // console.log(mp3URL);
      // // create download link and append to Dom
      // const downloadLink = document.createElement("a");
      // downloadLink.href = mp3URL;
      // downloadLink.innerText = "Download";
      // downloadLink.style.float = 'right';
      // downloadLink.setAttribute("download", "my-audio.mp3"); // name file
      // document.getElementById("root").appendChild(downloadLink);
      this.loadChannelEncodedBuffer(arrayBufferWav, message.data.index);

    }
    if (message.event === 'data-transfer-current-engine-state') {
      // console.log(message.value);
      this.currentPosition = message.value.currentPosition;
      this.peaks = message.value.peaks;
    }
    if (message.event === 'data-transfer-punch-in-point') {
      // console.log(message.value);
      
    }
    if (message.event === 'data-transfer-punch-out-point') {
      // console.log(message.value);
      // this.currentPosition = message.value;
    }
    if (message.event === 'worklet-log') {
      // console.log(message);
      // this.currentPosition = message.value;
      
      if (message.payload.includes('WASM memory')) {
        let ramUsage = message.payload.split(',')[2].replace(' total.','').trim();
        window.ramUsage = ramUsage
        // const ramElement = document.getElementById('ram-display');
        // if (ramElement) ramElement.innerHTML = window.ramUsage;
      }
    }
    if (message.event === 'error') {
      alert(message.message);
    }
  }

  sendRequestCurrentEngineStateCommand() {
    if (this.processorNode) {
      this.processorNode.sendMessageToAudioScope({
        type: "command",
        payload: {
          id: "requestCurrentEngineState",
        },
      }); 
    }
  }

  sendSeekCommand(value) {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "seek",
        value
      },
    });
  }


  sendRequestPunchInPointCommand() {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "setAndRequestPunchInPoint",
      },
    });
  }

  sendRequestPunchOutPointCommand() {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "setAndRequestPunchOutPoint",
      },
    });
  }

  sendPlayCommand(offlineContext = false) {

	if (doprint) console.log("pgw sendPlayCommand offlineContext = ", offlineContext)

    if (!offlineContext) {
		if (this && this.webaudioManager && this.webaudioManager.audioContext) {
			if (doprint) console.log("sendPlayCommand this.webaudioManager.audioContext defined ")
			this.webaudioManager.audioContext.resume();
		}
		else {
			if (doprint) console.log("sendPlayCommand this.webaudioManager.audioContext NOT defined ")
		}
	}

    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "startPlayback",
      },
    });
    this.playing = true;
  }

  sendLoopCommand(startMs, endMs) {

	if (doprint) console.log("pgw sendLoopCommand startMs = ", startMs)
	if (doprint) console.log("pgw sendLoopCommand endMs = ", endMs)

	// pgw 26-jul-2024 check that this.webaudioManager.audioContext is defined before using it
	if (this && this.webaudioManager && this.webaudioManager.audioContext) {
		if (doprint) console.log("sendLoopCommand this.webaudioManager.audioContext defined ")
	}
	else {
		if (doprint) console.log("sendLoopCommand this.webaudioManager.audioContext NOT defined ")
		return
	}



	// pgw 03-mar-2025 - testing fix loop bug
	// return;

	/*
	if (!startMs && !endMs) {
		// this.isLooping = false;
		return;
	}
	*/

	if (this.webaudioManager && this.webaudioManager.audioContext) {
		this.webaudioManager.audioContext.resume();
		if (this.processorNode) this.processorNode.sendMessageToAudioScope({
		  type: "command",
		  payload: {
			id: "setLoop",
			times: {
			  startMs,
			  endMs
			}
		  },
		});
		if (!startMs && !endMs) {
		  this.isLooping = false;
		} else {
		  this.isLooping = true;
		}
	}

  }

  sendPauseCommand() {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "pausePlayback",
      },
    });
    this.playing = false;
  }

  sendStopCommand() {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "stopPlayback",
      },
    });
    this.playing = false
  }

  sendStopRecordCommand() {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "stopRecording",
      },
    });
    this.recording = false;
    this.playing = false;
  }

  sendRecordCommand() {
    this.webaudioManager.audioContext.resume();
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "startRecording",
      },
    });
    this.recording = true;
  }

  sendMasterMuteCommand(value) {
    // console.log(this);
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "setMasterMute",
        value
      },
    });
  }

  loadSamplerBuffer(buffer) {
    this.webaudioManager.audioContext.resume();
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "loadSamplerBuffer",
        buffer: buffer,
      },
    });
  }

  async createAudioWorklet(channelCount, offline = false) {
    // console.log(this.webaudioManager);
    await this.webaudioManager.audioContext.audioWorklet.addModule(/* webpackIgnore: true */
      `${process.env.PUBLIC_URL}/processorScripts/mixer-processor.js`
    );

    const getWasmResponse = await fetch(
      `${process.env.PUBLIC_URL}/lib/superpowered/superpowered.wasm`,
      {
        mode: "cors",
        redirect: "follow"
      }
    );
    let WASMBytes = await getWasmResponse.arrayBuffer();

    this.processorNode = new AudioWorkletNode(
      this.webaudioManager.audioContext,
      "mixer-processor",
      {
        processorOptions: {
          moduleBytes: WASMBytes,
          samplerate: this.webaudioManager.audioContext.sampleRate,
          channelCount
        },
        numberOfInputs: 1,
        numberOfOutputs: 1,
        outputChannelCount: [2]
      }
    );
    // WASMBytes = null;
    
    // Setup worklet ports and handlers
    this.processorNode.onprocessorerror = (event) => {
      console.error(event);
    };
    this.processorNode.port.onmessage = (e) => this.onMessageProcessorAudioScope(e.data);
    this.processorNode.sendMessageToAudioScope = (data) => this.processorNode.port.postMessage(data);

    if (!offline) this.webaudioManager.audioContext.suspend();
    this.processorNode.connect(this.webaudioManager.audioContext.destination);
    // this.splitter = this.webaudioManager.audioContext.createChannelSplitter(2);
    
    // this.testTone.connect(this.stereoNode);
    this.stereoInputNode.connect(this.processorNode);
    // this.splitter.connect(this.processorNode, 0, 0);
    // this.splitter.connect(this.processorNode, 1, 0);
    // this.testTone.connect(this.webaudioManager.audioContext.destination);
    if (!offline) this.webaudioManager.audioContext.resume();
  }


// The AudioContext was not allowed to start. It must be resumed (or created) after a user gesture on the page. https://goo.gl/7K7WLu

  async requestUserMicrophone() {
    if (!this.userGrantedInput) {
      this.userInputStream = await this.webaudioManager.getUserMediaForAudioAsync({ 'fastAndTransparentAudio': true });
      if (!this.userInputStream) throw Error('Could no access user microphone');
      
      this.userInputStreamSourceNode = this.webaudioManager.audioContext.createMediaStreamSource(this.userInputStream);
      this.userInputStreamSourceNode.connect(this.stereoInputNode);

      this.userGrantedInput = true;
    }
    
    return this.userGrantedInput;
  }

  async removeChannel(index) {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "removeChannel",
        index
      },
    });
    return true;
  }

  make_download(abuffer, total_samples) {
    var new_file = URL.createObjectURL(bufferToWave(abuffer, total_samples));
    var download_link = document.getElementById("download_link");
    download_link.href = new_file;
    var name = generateFileName();
    download_link.download = name;
  }

  async getAudioContextRender(fileName) {
    this.sendPlayCommand(true);
    const renderedBuffer = await this.webaudioManager.audioContext.startRendering();
      // console.log('Rendering completed successfully', renderedBuffer);

      const downloadLink = document.createElement("a");
      var renderUrl = URL.createObjectURL(bufferToWave(renderedBuffer, renderedBuffer.length));

      var name = generateFileName();
      downloadLink.href = renderUrl;
      downloadLink.download = name;
      downloadLink.style.display = 'none';
      downloadLink.setAttribute("download", `${fileName}.wav`); // name file
      document.getElementById("root").appendChild(downloadLink);
      downloadLink.click();
  }

  async destroyAudioWorklet() {
    if (this.processorNode) {
      
      this.stereoInputNode.disconnect(this.processorNode);
      this.processorNode.disconnect(this.webaudioManager.audioContext.destination);
      this.processorNode.sendMessageToAudioScope({type: 'destruct'});
      // this.processorNode.destruct();
      this.processorNode = null;
    }
  }

  destructProcessorMixerEngine(newChannelCount) {
    // console.log('destructProcessorMixerEngine in audioEngine')
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({type: 'destruct-mixer-engine', payload: {
      newChannelCount
    }});
  }

  loadChannelBuffers(buffers) {
    // console.log('loadChannelBuffers');
    this.webaudioManager.audioContext.resume();
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "loadChannelBuffers",
        buffers: buffers,
      },
    });
  }

  loadChannelEncodedBuffer(encodedBuffer, index) {
    // console.log('loadChannelEncodedBuffer')
    return new Promise((resolve, reject)=> {
      this.loadSingleBufferCallback = resolve;
      if (this.processorNode) this.processorNode.sendMessageToAudioScope({
          type: "command",
          payload: {
            id: "loadChannelEncodedBuffer",
            encodedBuffer,
            index
          },
        });
        // null for garbage collection on main thread;
        encodedBuffer = null;
    });   
  }

  loadChannelEncodedBuffers(encodedBuffers) {
    // console.log('loadChannelEncodedBuffers ae');
    return new Promise((resolve, reject)=> {
      this.loadMultipleBuffersCallback = resolve;
      if (this.processorNode) this.processorNode.sendMessageToAudioScope({
        type: "command",
        payload: {
          id: "loadChannelEncodedBuffers",
          encodedBuffers
        },
      });
      // null for garbage collection on main thread;
      encodedBuffers = null;
    });
    
    
  }

  loadAssets(assets) {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "loadPlayerAssets",
        assets: assets,
      },
    });
  }

  addInputChannel(name, duration, channelId) {

	// pgw 30-mar-2026 testing
	// console.log("addInputChannel p1 name = ", name);
	// console.log("addInputChannel p1 duration = ", duration);


    this.webaudioManager.audioContext.resume();
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "addNewChannel",
        name,
        duration,
        channelId: channelId
      },
    });
  }

  sendChannelParamChange(channelIndex, paramName, value) {
    // console.log(channelIndex, paramName, value);
    // this.webaudioManager.audioContext.resume();
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "parameterChange",
      data: {
        scope: "channel",
        paramName: paramName,
        channelIndex: channelIndex,
        value: value,
      },
    });
  }

  sendGlobalParamChange(paramName, value) {
    // this.webaudioManager.audioContext.resume();
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "parameterChange",
      data: {
        scope: "global",
        paramName: paramName,
        channelIndex: null,
        value: value,
      },
    });
  }
}

function generateFileName() {
  var origin_name = 'offlineRender.wav';
  var pos = origin_name.lastIndexOf('.');
  var no_ext = origin_name.slice(0, pos);

  return no_ext + ".wav";
}

// Convert an AudioBuffer to a Blob using WAVE representation
function bufferToWave(abuffer, len) {
  var numOfChan = abuffer.numberOfChannels,
      length = len * numOfChan * 2 + 44,
      buffer = new ArrayBuffer(length),
      view = new DataView(buffer),
      channels = [], i, sample,
      offset = 0,
      pos = 0;

  // write WAVE header
  setUint32(0x46464952);                         // "RIFF"
  setUint32(length - 8);                         // file length - 8
  setUint32(0x45564157);                         // "WAVE"

  setUint32(0x20746d66);                         // "fmt " chunk
  setUint32(16);                                 // length = 16
  setUint16(1);                                  // PCM (uncompressed)
  setUint16(numOfChan);
  setUint32(abuffer.sampleRate);
  setUint32(abuffer.sampleRate * 2 * numOfChan); // avg. bytes/sec
  setUint16(numOfChan * 2);                      // block-align
  setUint16(16);                                 // 16-bit (hardcoded in this demo)

  setUint32(0x61746164);                         // "data" - chunk
  setUint32(length - pos - 4);                   // chunk length

  // write interleaved data
  for(i = 0; i < abuffer.numberOfChannels; i++)
    channels.push(abuffer.getChannelData(i));

  while(pos < length) {
    for(i = 0; i < numOfChan; i++) {             // interleave channels
      sample = Math.max(-1, Math.min(1, channels[i][offset])); // clamp
      sample = (0.5 + sample < 0 ? sample * 32768 : sample * 32767)|0; // scale to 16-bit signed int
      view.setInt16(pos, sample, true);          // write 16-bit sample
      pos += 2;
    }
    offset++                                     // next source sample
  }

  // create Blob
  return new Blob([buffer], {type: "audio/wav"});

  function setUint16(data) {
    view.setUint16(pos, data, true);
    pos += 2;
  }

  function setUint32(data) {
    view.setUint32(pos, data, true);
    pos += 4;
  }
}

const audioEngine = new AudioEngine();

export default audioEngine;
